import {AppIdentifier, appIdentifierToActionPrefixMap} from "../../types";
import {ACTION_APP_LOADED, ACTION_SET_JWT, ACTION_SET_MODAL_STATE} from "./constants";

export interface ICryptoAccountLinkState {
  jwt: string;
  isAppLoaded: boolean;
  isAppActive: boolean;
}

export interface ICryptoAccountLinkAction {
  type: string;
  jwt?: string;
  isAppActive?: boolean;
  isAppLoaded?: boolean;
}

const INITIAL_STATE: ICryptoAccountLinkState = {
  jwt: "",
  isAppActive: false,
  isAppLoaded: false
}

const applySetIsAppActive = (state: ICryptoAccountLinkState, action: ICryptoAccountLinkAction): ICryptoAccountLinkState => {
  return {
    ...state,
    isAppActive: !!action.isAppActive,
  }
}

const applySetSendJWTToApp = (state: ICryptoAccountLinkState, action: ICryptoAccountLinkAction): ICryptoAccountLinkState => {
  return {
    ...state,
    isAppLoaded: !!action.isAppLoaded,
  }
}

const applySetJWT = (state: ICryptoAccountLinkState, action: ICryptoAccountLinkAction): ICryptoAccountLinkState => {
  return {
    ...state,
    jwt: action.jwt as string,
  }
}

const reducerMap: {
  [actionType: string]: (state: ICryptoAccountLinkState, action: ICryptoAccountLinkAction) => ICryptoAccountLinkState
} = {
  [`${appIdentifierToActionPrefixMap.get(AppIdentifier.CRYPTO_ACCOUNT_LINK)}${ACTION_SET_JWT}`]: applySetJWT,
  [`${appIdentifierToActionPrefixMap.get(AppIdentifier.CRYPTO_ACCOUNT_LINK)}${ACTION_SET_MODAL_STATE}`]: applySetIsAppActive,
  [`${appIdentifierToActionPrefixMap.get(AppIdentifier.CRYPTO_ACCOUNT_LINK)}${ACTION_APP_LOADED}`]: applySetSendJWTToApp,
};

const cryptoAccountLinkReducer = (state = INITIAL_STATE, action: ICryptoAccountLinkAction) => {
  if (!!action.type && !!reducerMap[action.type]) {
    return reducerMap[action.type](state, action);
  } else {
    return state;
  }
}

export default cryptoAccountLinkReducer;
